import { CbShadowSubtle } from '@coolblue-development/design-tokens';
import { Chip, ChipGroup } from '@coolblue-development/freddy';
import { Clock, PinOutlined } from '@coolblue-development/icons';
import { useTranslation } from '@i18n/useTranslation';
import { type ChipUSPs as ChipUSPsType, ChipUSPsVariant } from '@sharedTypes';

import { LocationSelector } from './LocationSelector';
import { Relocation } from './Relocation';
import { Salary } from './Salary';

type Props = {
  chipUSPs: ChipUSPsType;
};

export const ChipUSPs = ({ chipUSPs }: Props) => {
  const { t } = useTranslation('vacancyDetail.header');

  const LocationChip = () => {
    switch (chipUSPs.variant) {
      case ChipUSPsVariant.LocationSpecific:
        return <Chip startIcon={<PinOutlined />}>{chipUSPs.location.displayName}</Chip>;
      case ChipUSPsVariant.Group:
        return <LocationSelector locations={chipUSPs.locations} />;
    }
  };

  return (
    <ChipGroup
      size={{ sm: 'small', md: 'medium' }}
      sx={{ '> span': { boxShadow: CbShadowSubtle } }}
    >
      {chipUSPs.relocationPossible && <Relocation />}
      {LocationChip()}

      <Chip startIcon={<Clock />}>
        {t('hours', {
          min: chipUSPs.hoursRange.min,
          max: chipUSPs.hoursRange.max
        })}
      </Chip>
      <Salary salaryValue={chipUSPs.salaryValue} salaryRange={chipUSPs.salaryRange} />
    </ChipGroup>
  );
};
